"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = exports.Link = void 0;
var _react = _interopRequireDefault(require("react"));
var _index = require("../TextLink/index.js");
var _styledComponents = _interopRequireDefault(require("../../styled-components.js"));
var Link = exports.Link = (0, _styledComponents["default"])( /*#__PURE__*/_react["default"].forwardRef(function Link(props, ref) {
  return /*#__PURE__*/_react["default"].createElement(_index.TextLink, Object.assign({
    semanticColor: "textBase",
    standalone: true,
    ref: ref
  }, props));
})).withConfig({
  displayName: "Link",
  componentId: "sc-fe80qw-0"
})(["display:block;"]);
var _default = exports["default"] = Link;